/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdTags202,
  PutApiV1PersonIdTags400,
  PutApiV1PersonIdTags401,
  PutApiV1PersonIdTags404,
  PutApiV1PersonIdTags500,
  PutApiV1PersonIdTagsMutationRequest,
  PutApiV1PersonIdTagsMutationResponse,
  PutApiV1PersonIdTagsPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdTags.ts";
import { personTagsViewModelSchema } from "../personTagsViewModelSchema.ts";
import { updatePersonTagsViewModelSchema } from "../updatePersonTagsViewModelSchema.ts";

export const putApiV1PersonIdTagsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdTagsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdTags202Schema = z.lazy(
  () => personTagsViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdTags202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdTags400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTags400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdTags401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTags401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdTags404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTags404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdTags500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTags500>;

export const putApiV1PersonIdTagsMutationRequestSchema = z.lazy(
  () => updatePersonTagsViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdTagsMutationRequest>;

export const putApiV1PersonIdTagsMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdTags202Schema,
) as unknown as ToZod<PutApiV1PersonIdTagsMutationResponse>;
